<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.billStatus === 'Y'
              ? 'success'
              : row.billStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ row.billStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.stockBatchReturnCode }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.billStatus === 'N'"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.stockBatchReturnCode }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.billStatus === 'N'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.stockBatchReturnCode)"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('C')"
            v-show="row.billStatus === 'N'"
          >
            <i
              class="el-icon-check tool-btn"
              @click="audit(row.stockBatchReturnCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .sampleStockBatchReturnDelApi({ stockBatchReturnCode: code })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    audit(code) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .sampleStockBatchReturnAuditApi({ stockBatchReturnCode: code })
          .then((res) => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'samplemanage-billStockBatchReturn-detail',
        params: { ...params, pageType }
      })
    }
  }
}
</script>
